import Navbar from "@/components/landing/Navbar";
import MammaHero from "@/components/landing/MammaHero";
import MammaMomento from "@/components/landing/MammaMomento";
import MammaCapas from "@/components/landing/MammaCapas";
import MammaSistema from "@/components/landing/MammaSistema";
import MammaArquitectura from "@/components/landing/MammaArquitectura";
import MammaCronograma from "@/components/landing/MammaCronograma";
import MammaInversion from "@/components/landing/MammaInversion";
import Stats from "@/components/landing/Stats";
import AboutUs from "@/components/landing/AboutUs";
import Testimonials from "@/components/landing/Testimonials";
import ChiappellaGarantia from "@/components/landing/ChiappellaGarantia";
import MammaCTA from "@/components/landing/MammaCTA";
import Footer from "@/components/landing/Footer";

const Index = () => {
  return (
    <main className="min-h-screen bg-background">
      <Navbar />
      <MammaHero />
      <MammaMomento />
      <MammaCapas />
      <MammaSistema />
      <MammaArquitectura />
      <MammaCronograma />
      <Stats />
      <AboutUs />
      <Testimonials />
      <MammaInversion />
      <ChiappellaGarantia />
      <MammaCTA />
      <Footer />
    </main>
  );
};

export default Index;
